// @flow
import * as React from 'react';
import i18n from 'app/common/lib/i18n';
import { Icon } from 'gestalt';

const IconVerifiedIdentity = () => (
  <Icon
    accessibilityLabel={i18n._('User identity is verified', 'Label for the verified identity icon')}
    color="red"
    icon="check-circle"
    size={16}
  />
);

export default IconVerifiedIdentity;
